import type { WorkspaceState } from './model';
/** The local key and media store stay stable. Old selections belong to the main slot. */
export function migrateState(raw: unknown): WorkspaceState {
  if (!raw || typeof raw !== 'object') throw new Error('invalid state');
  const value = raw as WorkspaceState;
  if (!Array.isArray(value.programs) || !Array.isArray(value.takes) || !Array.isArray(value.locks)) throw new Error('invalid state');
  return { ...value, schemaVersion: 3,
    programs: value.programs.map(p => ({ ...p, slots: p.slots?.length ? p.slots : [{ id: 'main', label: '보낼 영상', repertoireIds: [] }] })),
    takes: value.takes.map(t => ({ ...t, slotId: t.slotId ?? 'main' })),
    locks: value.locks.map(l => ({ ...l, slotId: l.slotId ?? 'main' })),
    proofs: value.proofs ?? [], manualChecks: value.manualChecks ?? {}, preparations: value.preparations ?? {},
  };
}
